import { IconWrapper } from '../runtime';
export default IconWrapper('form_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#0086A0"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#09B2D4"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M14.3438 4.03125H9.92473L7.9091 6.84375H4.03125V8.71875H8.87215L10.8878 5.90625H12.4688V12.4688H5.90625V9.84375H4.03125V14.3438H14.3438V4.03125Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.24985 4.03125H5.23125L4.03125 5.71875H7.04985L8.24985 4.03125Z",
      "fill": "white"
    }
  })]);
});